import React,{ Component } from 'react';
import $ from 'jquery';
import {Link} from 'react-router';
import Swiper from 'react-id-swiper';

export default class WebdealBlocks extends Component{
	constructor(props){
		super(props);
		this.state={
		  deal_offers: [],
      deal_details:[],
      arrowImage:'',
      dealoffer_name:'',
      bgImage:'',
      deal_bg_img:'',
		};
		this.getStoreBlocks=this.getStoreBlocks.bind(this);
    this.getblockDetails=this.getblockDetails.bind(this);
    this.goNext = this.goNext.bind(this)
    this.goPrev = this.goPrev.bind(this)
	}
	componentDidMount()
  {
      this.getStoreBlocks();
	}
  getStoreBlocks()
  {
      var baseUrl='https://aquadeals.in/admin/web3/user/';
      var data1={from:'desktop_web',};
      var data2=JSON.stringify(data1);
      $.ajax({
          method:'post',
          url:baseUrl+'getdealOffers',
          dataType:'json',
          data: {req:data2},
          success:function(data)
          {
            this.setState({
              deal_offers: data.deal_offers,
            });
            this.getblockDetails(data.deal_offers[0].id);
          }.bind(this),
          error:function(err)
          {
          }
      });
  }
  getblockDetails(block_id)
  {
    this.setState({
      arrowImage: block_id,
    });
    var baseUrl='https://aquadeals.in/admin/web3/user/';
    var data1={from:'desktop_web',id:block_id};
    var data2=JSON.stringify(data1);
    $.ajax({
      method: 'POST',
      url:baseUrl+'getOfferDeals',
      dataType:'json',
      data:{req:data2},
      success:function(data)
      {
        this.setState({
          deal_details:data.deal_blocks,
          deal_bg_img: 'https://aquadeals.in/admin/assets/images/'+data.blck_img,
          dealoffer_name:data.arrayname,
        });
      }.bind(this),
      error:function(err)
      {
        
      }
    });
  }
  goNext()
  {
      if(this.swiper) this.swiper.slideNext()
  }
  goPrev()
  {
      if(this.swiper) this.swiper.slidePrev()
  }

	render(){
		const params = {
	      paginationClickable: true,
	      spaceBetween: 30,
	      slidesPerView: 5.5
	    }
	    var mob_swipe_blocks = this.state.deal_offers.map(function(block,index){
        return(
          <div className="swipe_blocks_list" onClick={()=> {this.getblockDetails(block.id)} }>
            {block.img ==='' ? '' : <img className="web_sw_pic" src={'https://aquadeals.in/admin/assets/images/'+block.img} alt=" " /> }
            <p className="block_name">{block.type}</p>
            <p className="block_arrow">{this.state.arrowImage === block.id ? <img src={'https://aquadeals.in/admin/assets/images/'+block.arrow_img } alt=" " /> : ''}</p>
          </div>
        );
      }.bind(this));
      var swipe_all='';
      if(this.state.deal_details.length > 0){
        swipe_all=this.state.deal_details.map(function(block,index){
          return(
            <div className={block.pro_title ==="View More" ? "swipe_dtls_content1" : "web_swipe_dtls_content"}>
              {this.state.dealoffer_name==="Imported" ? 
              <Link to={'/web/pdeals/'+block.url_dtype+'/'+block.url_name+'/'+block.id+'/'+block.type+'/'+block.pro_id} >
                  {block.image ==='' ? '' : <i className="web_store_img"><img className="web_sw_dtls_img" src={'https://aquadeals.in/admin/assets/images/'+block.image} alt=" " /></i> }
                  {block.pro_title ? <h5 className="web_dtls_name">{block.pro_title}</h5> : <h5 className="web_dtls_name">&nbsp;</h5>}
                  {block.brand_name ? <h6 className="web_sw_brand_name">{block.brand_name}</h6> : <h6 className="web_sw_brand_name">&nbsp;</h6>}
                  {block.mrp ? <p className="web_sw_dtls_price">MRP ₹ {block.mrp}</p> : <p className="web_sw_brand_price">&nbsp;</p> }
              </Link>
              :
              <div>
              {block.pro_title==="View More" ? 
              <Link to={'/stores/'+block.url_name+'/'+block.id} >
                {block.image ==='' ? '' : <img className="sw_dtls_img" src={'https://aquadeals.in/admin/assets/images/'+block.image} alt=" " />}
                <h5 className="m_dtls_name organic_dtls_name">{block.pro_title}</h5>
              </Link> :
              <Link to={'/web/pdetails/'+block.url_dtype_name+'/'+block.url_cat_name+'/'+block.url_brand_name+'/'+block.url_product_name+'/'+block.pro_id+'/'+block.id}> 
                {block.image ==='' ? '' : <i className="web_store_img"><img className="web_sw_dtls_img" src={'https://aquadeals.in/admin/assets/images/'+block.image} alt=" " /></i>}
                {block.pro_title ? <h5 className="web_dtls_name">{block.pro_title}</h5> : <h5 className="web_dtls_name">&nbsp;</h5>}
                {block.brand_name ? <h6 className="web_sw_brand_name">{block.brand_name}</h6> : <h6 className="web_sw_brand_name">&nbsp;</h6> }
                {block.mrp ? <p className="web_sw_dtls_price">MRP ₹ {block.mrp}</p> :<p className="web_sw_dtls_price">&nbsp;</p>}
              </Link> }
              </div>
            }
            </div>
          );
        }.bind(this));
      }
		return(
			<div className="container" style={{marginTop:'10px',marginBottom:'10px',paddingTop:'10px',paddingBottom:'10px'}}>
        <h2 className="cat_store_title">Stores</h2>
        <Swiper {...params} key={mob_swipe_blocks.length}>
              {mob_swipe_blocks}
        </Swiper>
        <div className="web_swipe_imp_bg" style={{background:'url('+ this.state.deal_bg_img +')'}}>
            {swipe_all.length > 0 ? 
                <Swiper {...params} key={swipe_all.length}>
                   {swipe_all}
                </Swiper> 
            :''
            }
        </div>
      </div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/Web_DealBlocks.js
 **/